export interface IApplicationState {
    streakEffectList: any
    showStreak: boolean
}

const initialState: IApplicationState = {
    streakEffectList: [],
    showStreak: false
};

export enum actionTypes {
    SET_SRTEAKEFFECT_LIST = '@@giantWild/SET_SRTEAKEFFECT_LIST',
    SHOW_STREAK_ANIM = '@@giantWild/SHOW_STREAK_ANIM',
    RESET_REEL_STATE = '@@grid/RESET_REEL_STATE',
}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const { streakEffectList, showStreak } = action;

    switch (action.type) {
        case actionTypes.SET_SRTEAKEFFECT_LIST:
            return {
                ...state,
                streakEffectList: streakEffectList
            };
        case actionTypes.SHOW_STREAK_ANIM:
            return {
                ...state,
                showStreak: showStreak
            };
            case actionTypes.RESET_REEL_STATE:
                
                return {
                    ...state,
                    streakEffectList: []
                }
        default:
            return state;
    }
}

export const actions = {
    setStreakList: (streakEffectList: any): any => ({
        type: actionTypes.SET_SRTEAKEFFECT_LIST,
        streakEffectList
    }),
    showStreakAnimation: (showStreak: any): any => ({
        type: actionTypes.SHOW_STREAK_ANIM,
        showStreak
    }),
};
